module.exports = __webpack_public_path__ + "b6c4f22d64c510da1023676ebc07726f.pdf";